import {observable, action} from 'mobx';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import _ from "lodash";

class ProviderStore{

  @observable providers=[];
  @observable provider=null;
  //@observable provider_documents=[];

  @action
  setInitialState = ()=>{
    return this.provider = {
      name: '',
      profile_logo_url: null,
      email: '',
      phone: '',
      website: '',
      facebook_link: '',
      linkedin_link: '',
      twitter_link: '',
      user_type: '',
      bio: '',
      qualifications: '',
      provided_workshops: []
    }
  }

  // @action
  // getCurrentProvidedWorkshops = (current_workshops)=>{
  //  this.provided_workshops = current_workshops
  // };

  @action
  setProvidedWorkshops =(data) => {
    this.provider.provided_workshops = data.map(el => {
      let newObj = {};
      return {...newObj, id: el.id || null, title: el.label, workshop_type: el.workshop_type}
    });
    console.warn(' this.provider.provided_workshops FROM setProvidedWorkshops ', this.provider.provided_workshops);
    //return this.provided_workshops
  }

  @action
  deleteCurrentProvidedWorkshop(id){
    //debugger;
    console.warn('this.provider.provided_workshops(id) this.provider.provided_workshops', this.provider.provided_workshops);
    this.provider.provided_workshops = this.provider.provided_workshops.filter(el=>el.title!==id)
  }

  @action
  getProviders(providers){
    this.providers = providers;
    return this.providers
  }


  @action
  getProvider(id){
    let currentProvider = this.providers.find(el=> el.id == id);
    this.provider=currentProvider;
    //return this.provider
  }


  @action updateProvider = data => {
    let provider = {}
    _.mapKeys(data, (value, key) => {
      if(key === 'user_type'){
        let value = null;
        switch(data.user_type){
          case 'counsellor':
            value = '0';
            break;
          case 'psychotherapist':
            value = '1';
            break;
          case 'psychiatrist':
            value = '2';
            break;
          case 'student':
            value = '3';
            break;
          case 'other':
            value = '4';
            break;
        }
        _.assign(provider, {[key]: value});
      }
      else if(key==='provided_workshops'){
        _.assign(provider, {[key]: JSON.parse(JSON.stringify(data[key]))});
      }
      // else if(key === 'bio'){
      //   _.assign(provider, {[key]: this.htmlToDrafJs(value)});
      // }
      // else if(key === 'qualifications'){
      //   _.assign(provider, {[key]: this.htmlToDrafJs(value)});
      // }
      else  {
        _.assign(provider, {[key]: value ? value: ''})
      }
    })

    this.provider = provider;
    return this.provider;
  }


  htmlToDrafJs = html => {
    const {contentBlocks, entityMap} = htmlToDraft(html);
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    return EditorState.createWithContent(contentState);
  };

  @action
  clearCurrentProvider(){
    this.provider = null
  }

}


export default new ProviderStore()



// WEBPACK FOOTER //
// ./src/stores/ProviderStore.js